module.exports = __webpack_public_path__ + "static/img/testImgLogin.8fba8136.png";